<div class="spacing-top"></div>

<div class="main-step">
	<div class="spacing-top justify-content-end bg-transparent">
		<span data-testid="SUBSYS4_TOOLSMENU_UNDO_BTN" class="material-icons material-icons-outlined px-2 active"
			[class.disabled]="!isUndoEnabled" (click)="undo()" (keypress)="undo()">undo</span>
		<span data-testid="SUBSYS4_TOOLSMENU_REDO_BTN" class="material-icons material-icons-outlined px-2 active"
			[class.disabled]="!isRedoEnabled" (click)="redo()" (keypress)="redo()">redo</span>
	</div>

	<image-elaboration [view]="activeView" />

	<deformity-menu />

	@if (isFitbone) {
	<rpm-menu />
	}
	@else if (isJPS) {
	<correction-menu />
	<jps-menu />
	}

	<!-- FOOTER MENU -->
	@if (isDeformityDone) {
	<div class="box-menu-settings active">

		@if (isPrintVisible) {
		<div data-testid="SUBSYS4_TOOLSMENU_PRINTOR_BTN" class="row-box clickable mt-5" (click)="printOR()"
			(keypress)="printOR()">
			<i class="material-icons">local_printshop</i>
			<span>{{ labels().TOOLS_MENU_COMPONENT_OR_PLAN }}</span>
		</div>
		}
		@if (stateType === stateTypeEnum.templating) {
		<div data-testid="SUBSYS4_TOOLSMENU_PRINTBOM_BTN" class="row-box clickable" (click)="printBom()"
			(keypress)="printBom()" [class]="{'clickable': isPlateInserted, 'disabled': !isPlateInserted }">
			<i class="material-icons">receipt</i>
			<span>{{ labels().TOOLS_MENU_COMPONENT_BOM }}</span>
		</div>
		}
	</div>
	}

</div>